<template>
	<v-col class="ma-0 pa-0" cols="12">
		<template v-if="fetchLoading">
			<v-col class="ma-0 pa-0 mt-4" cols="12"
				style="width:100%;height:316px;">
				<v-skeleton-loader :boilerplate="false" elevation="0" dark 
					type="image" width="100%" :height="316"
				></v-skeleton-loader>
			</v-col>
		</template>
		<template v-else>		
			<v-col class="ma-0 pa-0 pb-4" cols="12" id="chartBackground">
				<v-col class="pa-0 mt-4" id="main_content_maxwidthset" cols="12"
					style="position: relative;">
					<template v-if="showAge == false">
						<v-row class="ma-0 pa-0 pl-2">
							<v-col class="ma-0 pa-0 mt-8 pr-7 pl-9">
								<BarChart :chart-data="chartData" :options="chartOptions" :height="100"></BarChart>
							</v-col>
						</v-row>
						<v-col id="label_box" class="ma-0 pa-0 pl-4 pb-2" cols="12" align="left">
							<v-col class="ma-0 pa-0" cols="1" align="right">
								{{'顔認識率'}}
							</v-col>
						</v-col>
					</template>
					<template v-else>
						<v-row class="ma-0 pa-0 pl-4">
							<v-col class="ma-0 pa-0 mt-8 pr-7 pl-9" style="height:595px;"
								v-show="showAgeValue">
                <template v-if="showAgeValue">
								  <BarChart :chart-data="chartData" :options="chartOptions" :height="235"></BarChart>
                </template>
							</v-col>
							<v-col class="ma-0 pa-0 mt-8 pr-7 pl-9"
								v-show="!showAgeValue">
                <template v-if="!showAgeValue">
								  <BarChart :chart-data="chartData" :options="chartOptions" :height="100"></BarChart>
                </template>
							</v-col>
						</v-row>
						<v-col id="label_box" class="ma-0 pa-0 pl-4" cols="12" align="left"
							v-if="visitorData.length != 0 && showAgeValue">
							<v-col class="ma-0 pa-0" cols="1" align="right">
								{{ manOrWoman ? ta('man') : ta('repeat') + '全体'}}
							</v-col>
							<v-col class="ma-0 pa-0 pl-3" cols="1" align="right">{{'10代'}}</v-col>
							<v-col class="ma-0 pa-0 pl-3" cols="1" align="right">{{'20代'}}</v-col>
							<v-col class="ma-0 pa-0 pl-3" cols="1" align="right">{{'30代'}}</v-col>
							<v-col class="ma-0 pa-0 pl-3" cols="1" align="right">{{'40代'}}</v-col>
							<v-col class="ma-0 pa-0 pl-3" cols="1" align="right">{{'50代'}}</v-col>
							<v-col class="ma-0 pa-0 pl-3" cols="1" align="right">{{'60代'}}</v-col>
							<v-col class="ma-0 pa-0 pl-3" cols="1" align="right">{{'70代以上'}}</v-col>
							<v-col class="ma-0 pa-0 pl-3" cols="1" align="right">
								{{ manOrWoman ? ta('woman') : ta('new') + '全体'}}
							</v-col>
							<v-col class="ma-0 pa-0 pl-3" cols="1" align="right">{{'10代'}}</v-col>
							<v-col class="ma-0 pa-0 pl-3" cols="1" align="right">{{'20代'}}</v-col>
							<v-col class="ma-0 pa-0 pl-3" cols="1" align="right">{{'30代'}}</v-col>
							<v-col class="ma-0 pa-0 pl-3" cols="1" align="right">{{'40代'}}</v-col>
							<v-col class="ma-0 pa-0 pl-3" cols="1" align="right">{{'50代'}}</v-col>
							<v-col class="ma-0 pa-0 pl-3" cols="1" align="right">{{'60代'}}</v-col>
							<v-col class="ma-0 pa-0 pl-3" cols="1" align="right">{{'70代以上'}}</v-col>
						</v-col>
						<v-col id="label_box" class="ma-0 pa-0 pl-4" cols="12" align="left"
							v-if="visitorData.length != 0 && !showAgeValue"
								style="bottom:8px;">
							<v-col class="ma-0 pa-0 pl-3" cols="1" align="right">
								{{ manOrWoman ? ta('man') : ta('repeat') }}
							</v-col>
							<v-col class="ma-0 pa-0 pl-3" cols="1" align="right">
								{{ manOrWoman ? ta('woman') : ta('new') }}
							</v-col>
						</v-col>
					</template>
				</v-col>
				<template v-if="mode != 'hour' && mode != 'day'">
					<v-col id="no_data" class="ma-0 pa-0" cols="12"
						v-if="fetchLoading == false && monthNoData">
						{{t('noData')}}
					</v-col>
				</template>
				<template v-else>
					<v-col id="no_data" class="ma-0 pa-0" cols="12"
						v-if="visitorData.length == 0 && fetchLoading == false">
						{{t('noData')}}
					</v-col>
				</template>
			</v-col>
		</template>
	</v-col>
</template>

<script>
import mixin from '@/mixin';
import BarChart from "./barChart.js";
export default {
	props: {
		mode: { type: String, default: 'day' },
		fetchLoading: { type: Boolean, default: false },
		monthNoData: { type: Boolean, default: false },
		chartData: { type: Object },
		chartOptions: { type: Object },
		visitorData: { type: Array },
		showAge: { type: Boolean, default: false }, // 나이별 데이터 표시
		showAgeValue: { type: Boolean, default: false },
		manOrWoman: { type: Boolean, default: false }, // 남여, 신규or재방문 구분
	},
	components: {
		BarChart
	},
	mixins: [mixin.common],
	data: () => ({

	}),
	methods: {
		ta(t) {
      return this.$t("lang.allStoreAnalytics." + t);
    },
	}
}
</script>

<style lang="scss" scoped>
#chartBackground {
	background-color: #34363C;
	border-radius: 4px;
	position: relative;
}
#label_box {
	font-family: note-sans-jp-light;
	font-weight: 100;
	font-size: 0.8rem;
	position: absolute;
	bottom: 0;
	line-height: 1.4;
}
#no_data {
	font-size: 1rem;
	position: absolute;
	z-index: 2;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
}
::v-deep {
  .v-skeleton-loader__image {
    height: 316px;
	}
}
</style>